import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme/index.js';

var _templateObject;
var getFontSize = function getFontSize(_ref) {
  var size = _ref.size;
  switch (size) {
    case "small":
      return "12px";
    case "medium":
      return "14px";
    case "large":
      return "16px";
    default:
      return "12px";
  }
};
var Label = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: ", ";\n  color: ", ";\n  font-family: ", ";\n"])), getFontSize, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError ? Theme.colors.danger : Theme.colors.primary;
}, Theme.fonts.Montserrat);
var InputLabel = function InputLabel(_ref3) {
  var children = _ref3.children,
    touched = _ref3.touched,
    errors = _ref3.errors,
    field = _ref3.field,
    size = _ref3.size;
  var hasError = errors[field] && touched[field];
  return /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: field,
    hasError: hasError,
    name: field,
    size: size
  }, children, hasError ? " *" : null);
};
InputLabel.defaultProps = {
  errors: {},
  touched: {}
};
InputLabel.propTypes = {
  children: PropTypes.node.isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  field: PropTypes.string
};

export { Label, InputLabel as default, getFontSize };
